<p-dialog
  [visible]="request !== null"
  (visibleChange)="close()"
  (onShow)="focusInput()"
  [header]="request?.mode === 'delete' ? deleteTitle : renameTitle"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  appendTo="body"
  [style]="{width: '480px', 'max-width': '95vw'}"
>
  @if (request?.mode === 'rename') {
    <form (ngSubmit)="submit()">
      <label class="form-label fw-semibold" [for]="'variable-name-' + request?.variableId">{{ nameLabel }}</label>
      <input #nameInput pInputText class="w-100" type="text" name="variableName"
        [id]="'variable-name-' + request?.variableId" [(ngModel)]="name"
        (ngModelChange)="error = ''" [attr.aria-invalid]="error ? true : null"
        [attr.aria-describedby]="error ? 'variable-error-' + request?.variableId : null"
        autocomplete="off" />
      <div class="d-flex gap-2 mt-3 p-3 rounded bg-info-subtle text-info-emphasis">
        <i class="ri-information-line fs-5" aria-hidden="true"></i>
        <span>{{ renameHint }}</span>
      </div>
    </form>
  } @else {
    <p class="mb-3" style="overflow-wrap: anywhere">{{ deleteQuestion }}</p>
    <div class="d-flex gap-2 p-3 rounded bg-danger-subtle text-danger-emphasis">
      <i class="ri-error-warning-line fs-5" aria-hidden="true"></i>
      <span>{{ deleteWarning }}</span>
    </div>
  }
  @if (error) {
    <p class="text-danger mt-2 mb-0" role="alert" [id]="'variable-error-' + request?.variableId">{{ error }}</p>
  }
  <ng-template pTemplate="footer">
    <p-button [label]="cancelLabel" [text]="true" [plain]="true" (onClick)="close()" />
    <p-button [label]="request?.mode === 'delete' ? deleteLabel : renameLabel"
      [severity]="request?.mode === 'delete' ? 'danger' : 'primary'"
      [icon]="request?.mode === 'delete' ? 'ri ri-delete-bin-line' : 'ri ri-check-line'"
      [disabled]="request?.mode === 'rename' && !name.trim()" (onClick)="submit()" />
  </ng-template>
</p-dialog>
